import './Checkbox.scss';

const Checkbox = props => (
  <input type="checkbox" onChange={props.onChange} value="1" />
);

export default Checkbox;
